import DeleteModel from 'base/DeleteModal/DeleteModal';
import classNames from 'classnames';
import NavbarDual from 'components/navbars/navbar-dual/NavbarDual';
import NavbarTopHorizontal from 'components/navbars/navbar-horizontal/NavbarTopHorizontal';
import NavbarTopDefault from 'components/navbars/navbar-top/NavbarTopDefault';
import NavbarVertical from 'components/navbars/navbar-vertical/NavbarVertical';
import { t } from 'i18next';
import { useAppContext } from 'providers/AppProvider';
import { useMainLayoutContext } from 'providers/MainLayoutProvider';
import { Container } from 'react-bootstrap';
import { Outlet } from 'react-router-dom';

const MainLayout = () => {
  const {
    config: { navbarPosition, showUnAuthorizedModal, unAuthorizedModalMessage },
    setConfig
  } = useAppContext();

  const { contentClass } = useMainLayoutContext();

  const renderUnAuthorizedModal = () => {
    if (showUnAuthorizedModal) {
      return (
        <DeleteModel
          onCancel={() =>
            setConfig({
              showUnAuthorizedModal: false,
              unAuthorizedModalMessage: ''
            })
          }
          showConfirm={false}
          onConfirm={() => {}}
          title={unAuthorizedModalMessage}
          type="error"
          cancelText={t('general.common_text.text_23')}
        />
      );
    }
  };

  return (
    <Container fluid className="px-0">
      {(navbarPosition === 'vertical' || navbarPosition === 'combo') && (
        <NavbarVertical />
      )}
      {navbarPosition === 'vertical' && <NavbarTopDefault />}
      {(navbarPosition === 'horizontal' || navbarPosition === 'combo') && (
        <NavbarTopHorizontal />
      )}
      {navbarPosition === 'dual' && <NavbarDual />}

      <div className={classNames(contentClass, 'content')}>
        <Outlet />
        {renderUnAuthorizedModal()}
      </div>
    </Container>
  );
};

export default MainLayout;
